// extracted by mini-css-extract-plugin
export default {"card":"ServicesCard_card__a8to9","card_icon":"ServicesCard_card_icon__Qc5tT","card_text":"ServicesCard_card_text__gos8e"};